export default {
  applicationtitle: 'application publish'
};
